export default function Heading({
  title,
  description,
  "data-testid": dataTestId,
}: {
  title: string
  description?: string
  /**
   * OKS-799 — optional stable handle on the heading block. Added so the
   * Settings frame can assert "the verification prompt renders BELOW the
   * heading and ABOVE the tab nav" rather than the much weaker "renders
   * somewhere on the page". Purely additive; the 2 other call sites pass
   * nothing and render byte-identically.
   */
  "data-testid"?: string
}) {
  return (
    <div className="mb-8 space-y-0.5" data-testid={dataTestId}>
      <h2 className="text-xl font-semibold tracking-tight">{title}</h2>
      {description && (
        <p className="text-muted-foreground text-sm">{description}</p>
      )}
    </div>
  )
}
